import {useEffect,useState} from "react";

export default function LatestArticles(){
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("id-ID", {
            day: "numeric",
            month: "long",
            year: "numeric"
        });
    };


    const [articles,setArticles] = useState([])
        useEffect(()=>{
            fetch(process.env.REACT_APP_BASE_URL+"api/events?page=1")
            .then(res=>res.json())
            .then(data=>setArticles(data.data.slice(0,5)))
        },
    [])

    return(
        <div className="relative mt-40 rounded-2xl border border-white p-8">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-600/60 to-red-600/60 rounded-2xl blur-2xl"></div>
            <h3 className="font-bold text-lg mb-4 text-red-700">
                Artikel Terkini
            </h3>
            <div className="relative space-y-4">
                {articles.map(article=>(
                    <a
                        key={article.id}
                        href={`/post/${article.slug}`}
                        className="block hover:text-blue-600"
                    >
                        <p className="font-medium line-clamp-2">
                            {article.title}
                        </p>
                        <p className="text-xs text-white">
                            {formatDate(article.created_at)}
                        </p>
                    </a>
                ))}
            </div>
        </div>
    )

}